import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  HistoryIcon,
  Iicon,
  LockGreyIcon,
  TableMoreDetails,
  commentIcon,
  grayViewIcon,
  tableEditIcon,
} from "../../../../assets/images";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { LoginResponseType } from "../../../../redux/auth/authTypes";
import {
  GetAllOtherInvoicesListType,
  OtherInvoiceGenerationPaymentType,
} from "../../../../redux/invoiceGeneration/invoiceGenrationTypes";
import {
  formatDate,
  formateDateWithTime,
} from "../../../../utils/commonFunctions";
import Avatar from "../../../commons/CircularAvatar/CircularAvatar";
import { PaperClipIcon } from "../../../Icon";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";


type AppProps = {
  tableHeader: TableHeadersType[];
  data: GetAllOtherInvoicesListType[] | [];
  handleRedirectToEditForm: (data: GetAllOtherInvoicesListType) => void;
  handleRedirectToCopyForm: (data: GetAllOtherInvoicesListType) => void;
  client_code?: number;
  deleteOtherInvoice?: (other_id: number) => void;
  loginData: LoginResponseType;
  handleShowConfirmationModal: (id: number) => void;
  isEditOthersPresent?: boolean;
  handleToggleInvoiceCommentsModal?: () => void;
  handleSetInvoiceData: (data: any) => void;
  isViewOthersInvoicePresent?: boolean;
  isAddOthersPresent?: boolean;
  isOthersListCommentPresent?: boolean;
  currencySign: string | undefined;
  lockedOthersEntriesDate: null | string;
  isDeleteOthersEntries: boolean;
  toggleInvoiceHistory: (type: string, id: number) => void;
  isOthersHistory: boolean;
  handleCustomerSuplierDetailsData: (invoiceType: number) => void;
};

const AllOtherInvoicesListTableData = ({
  data,
  tableHeader,
  currencySign,
  handleRedirectToEditForm,
  handleRedirectToCopyForm,
  client_code,
  deleteOtherInvoice,
  loginData,
  handleShowConfirmationModal,
  isEditOthersPresent,
  isAddOthersPresent,
  handleToggleInvoiceCommentsModal,
  handleSetInvoiceData,
  toggleInvoiceHistory,
  isOthersHistory,
  isViewOthersInvoicePresent,
  isOthersListCommentPresent,
  lockedOthersEntriesDate,
  isDeleteOthersEntries,
  handleCustomerSuplierDetailsData,
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);
  const [sameIndex, setSameIndex] = useState<any>("-2");
  const handleMoreDataOpen = (data: any, index: any) => {
    setSameIndex(index);
    setToggle(!toggle);
  };

  const renderMoreDetailsInvoiceToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        More Details
      </Tooltip>
    );
  };

  const renderLockInvoiceToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        Invoice Locked
      </Tooltip>
    );
  };

  const renderEditInvoiceToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        Edit Invoice
      </Tooltip>
    );
  };

  const renderPaymentsData = (others_id: number, paymentData: any) => {
    // return (
    //   data?.length &&
    //   data?.map((item: GetAllOtherInvoicesListType) => {
    //     if (others_id === item?.others_id) {
    return (
      <>
        {paymentData?.length &&
          paymentData?.map((paymentData: OtherInvoiceGenerationPaymentType) => {
            return (
              <>
                <div className="d-flex flex-column my-2 px-2">
                  <div className="d-flex justify-content-between">
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: 500,
                      }}
                    >
                      <span style={{ marginRight: "0px" }}>{currencySign}</span>
                      {paymentData?.amount}
                    </span>
                    <span className="ml-2">
                      {paymentData?.transaction_type === "credit" ? (
                        <span className="credit">Credit</span>
                      ) : (
                        <span className="debit">Debit</span>
                      )}
                    </span>
                  </div>
                  <span style={{ color: "#676464", fontSize: "13px" }}>
                    {paymentData?.account_details?.ledger_name}

                    {(paymentData?.account_details?.ledger_type ===
                    "supplier_customer" || paymentData?.account_details?.ledger_type_id === 2 )? (
                      <img
                        className="ml-2 pointer"
                        src={Iicon}
                        alt="EyeIcon"
                        onClick={() =>
                          handleCustomerSuplierDetailsData?.(
                            paymentData?.account_details?.ledger_id
                          )
                        }
                      />
                    ) : (
                      ""
                    )}
                  </span>
                  <span style={{
                          color: "rgb(103, 100, 100)",
                          fontSize: "13px",
                        }}>
                    {paymentData?.account_details?.trade_name}
                  </span>
                </div>
              </>
            );
          })}
      </>
    );
    //   }
    // })
    // );
  };

  const renderTableData = () => {
    const finalTableData = data?.length
      ? data?.map((dataItem: any, index: number) => {
          let finalName = !dataItem?.first_name?.length
            ? `${dataItem?.company_name?.slice(0, 25)}...`
            : `${dataItem.first_name} ${dataItem?.last_name}`;
          let splitedLockedEntries: string | string[] = lockedOthersEntriesDate
            ? lockedOthersEntriesDate?.split("-")
            : "";
          let splitedInvoiceDate: string[] = formatDate(
            dataItem?.date_of_invoice
          )?.split("-");

          let lockedDate = new Date(
            +splitedLockedEntries[2],
            +splitedLockedEntries[1] - 1,
            +splitedLockedEntries[0]
          );
          let itemDate = new Date(
            +splitedInvoiceDate[2],
            +splitedInvoiceDate[1] - 1,
            +splitedInvoiceDate[0]
          );

          return (
            <tr key={dataItem?.others_id}>
              {tableHeader?.length &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header.value === "others_id") {
                    return <td>{`100000${dataItem?.others_id}`}</td>;
                  } else if (header.value === "date_of_invoice") {
                    return (
                      <td style={{ width: "140px" }}>
                        {formatDate(dataItem?.date_of_invoice)}
                      </td>
                    );
                  } else if (header.value === "upload") {
                    return !!dataItem?.upload?.length ? (
                      <td
                        style={{ width: "50px" }}
                        className="position-relative"
                      >
                        <PaperClipIcon />
                        <span className="badge count-badge">
                          {dataItem?.upload?.length}
                        </span>
                      </td>
                    ) : (
                      <td style={{ width: "50px" }}> --/-- </td>
                    );
                  } else if (header.value === "company_name") {
                    return (
                      <td style={{ textAlign: "center", width: "164px" }}>
                        <div className="d-flex flex-column">
                          {finalName}
                          <span className="due-date-text">
                            {formateDateWithTime(dataItem?.updated_at)}
                          </span>
                        </div>
                      </td>
                    );
                  } else if (header.value === "payment") {
                    return (
                      <td style={{ width: "185px" }}>
                        {renderPaymentsData(
                          dataItem?.others_id,
                          dataItem?.payment,
                        )}
                      </td>
                    );
                  } else if (header.value === "branch_details") {
                    if (!dataItem?.branch_details?.trade_name?.length) {
                      return <td> --/-- </td>;
                    }
                    return <td>{dataItem?.branch_details?.trade_name}</td>;
                  } 
                  else if (header.value === 'created_at') {
                    return <td style={{ width: '140px', textAlign: 'center' }}>
                      {formatDate(dataItem?.created_at)}
                    </td>
                  }
                  else if (header.value === "approved_by") {
                    return (
                      <td style={{ textAlign: "center" }}>
                        <div className="d-flex">
                          {dataItem?.approval_details?.length > 0 ? (
                            dataItem?.approval_details?.map(
                              (profileData: any) => {
                                let fullName =
                                  profileData?.first_name +
                                  " " +
                                  profileData?.last_name;

                                return (
                                  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 250 }}
                                    overlay={
                                      <Tooltip id="button-view-open-item">
                                        {fullName}
                                        <br></br>
                                        approved on{" "}
                                        {formateDateWithTime(
                                          profileData?.approved_at
                                        )}
                                      </Tooltip>
                                    }
                                  >
                                    <span style={{ cursor: "pointer" }}>
                                      <Avatar
                                        name={fullName}
                                        image={
                                          profileData?.profile_pic?.file_url
                                        }
                                      />
                                    </span>
                                  </OverlayTrigger>
                                );
                              }
                            )
                          ) : (
                            <span>--/--</span>
                          )}
                        </div>
                      </td>
                    );
                  } else {
                    return <td> --/-- </td>;
                  }
                })}
              <td style={{ width: "120px", textAlign: "center" }}>
                {isEditOthersPresent &&
                  (isViewOthersInvoicePresent || isEditOthersPresent) && (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        lockedOthersEntriesDate && itemDate <= lockedDate
                          ? renderLockInvoiceToolTip
                          : renderEditInvoiceToolTip
                      }
                    >
                      {lockedOthersEntriesDate && itemDate <= lockedDate ? (
                        <span className="d-inline-block pointer">
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                            }}
                          >
                            <img src={LockGreyIcon} alt="lock" />
                          </div>
                        </span>
                      ) : (
                        <span
                          className="d-inline-block pointer"
                          onClick={() => handleRedirectToEditForm?.(dataItem)}
                        >
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                            }}
                          >
                            {/* <i className="fas fa-pen"></i> */}
                            <img src={tableEditIcon} alt="edit" />
                          </div>
                        </span>
                      )}
                    </OverlayTrigger>
                  )}

                {isOthersHistory ? (
                  <span>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="history-tooltip">Invoice Audit</Tooltip>
                      }
                    >
                      <span className="d-inline-block pointer">
                        <div
                          style={{
                            color: "#d43",
                            fontSize: 20,
                            width: "30px",
                          }}
                          onClick={() =>
                            toggleInvoiceHistory("open", dataItem.others_id)
                          }
                        >
                          <img src={HistoryIcon} alt="" />
                        </div>
                      </span>
                    </OverlayTrigger>
                  </span>
                ) : null}

                {isViewOthersInvoicePresent && !isEditOthersPresent && (
                  <span
                    className="d-inline-block pointer"
                    onClick={
                      lockedOthersEntriesDate && itemDate <= lockedDate
                        ? () => {}
                        : () => handleRedirectToEditForm?.(dataItem)
                    }
                  >
                    <div>
                      {/* <img src={ViewIcon} alt ="view"/> */}
                      {lockedOthersEntriesDate && itemDate <= lockedDate ? (
                        <img src={LockGreyIcon} alt="lock" />
                      ) : (
                        <img src={grayViewIcon} alt="view" />
                      )}
                    </div>
                  </span>
                )}

                <span className="d-inline-block pointer ml-2">
                  {isOthersListCommentPresent && (
                    <>
                      <div
                        className="position-relative"
                        onClick={() => {
                          handleToggleInvoiceCommentsModal?.();
                          handleSetInvoiceData(dataItem);
                        }}
                      >
                        {dataItem?.comment_count != 0 && (
                          <span className="jobs-link-count">
                            {dataItem?.comment_count}
                          </span>
                        )}
                        <img src={commentIcon} alt="comment" />
                      </div>
                    </>
                  )}
                </span>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 250 }}
                  overlay={renderMoreDetailsInvoiceToolTip}
                >
                  <span
                    style={{ cursor: "pointer", width: "21px", height: "25px" }}
                    className="ml-2"
                    onClick={() => handleMoreDataOpen(dataItem, index)}
                  >
                    <img
                      style={{ width: "inherit" }}
                      src={TableMoreDetails}
                      alt="more"
                    />
                  </span>
                </OverlayTrigger>

                {+sameIndex === index && (
                  <ButtonDropdown
                    isOpen={toggle}
                    toggle={() => {
                      setToggle(!toggle);
                    }}
                  >
                    <DropdownToggle
                      caret
                      color="secondary"
                      style={{
                        background: "none",
                        color: "none",
                        opacity: "1",
                        position: "absolute",
                      }}
                    ></DropdownToggle>
                    <DropdownMenu right direction={"down"}>
                      <div
                        className="p-3 download-dropdown"
                        style={{ minWidth: "200px", display: "inline-block" }}
                      >
                        {deleteOtherInvoice &&
                        lockedOthersEntriesDate &&
                        itemDate <=
                          lockedDate ? null : isDeleteOthersEntries ? (
                          <span
                            className="radio-container-vertical"
                            onClick={() =>
                              handleShowConfirmationModal(dataItem.others_id)
                            }
                          >
                            Delete Entry
                          </span>
                        ) : null}
                        {isAddOthersPresent ? (
                          <span
                            onClick={() => handleRedirectToCopyForm?.(dataItem)}
                            className="radio-container-vertical"
                          >
                            Duplicate Entry
                          </span>
                        ) : null}
                        {lockedOthersEntriesDate && itemDate <= lockedDate ? (
                          <span
                            onClick={() => handleRedirectToEditForm?.(dataItem)}
                            className="radio-container-vertical"
                          >
                            View Entry
                          </span>
                        ) : null}
                      </div>
                    </DropdownMenu>
                  </ButtonDropdown>
                )}
              </td>
            </tr>
          );
        })
      : "";

    return finalTableData;
  };

  return <>{renderTableData()}</>;
};

export default AllOtherInvoicesListTableData;
